global.team_rn = null
